export default __webpack_public_path__ + "static/media/a0d8099a712faa9049341bb31fb3eafc1582144889291.e869a933.webp";